"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentOrigin = void 0;
/**
 * DRAWDOWN for payments of the back of a drawdown
 * SPOT_TRADE for payments of the back of a spot trade that has already been booked
 * DRAFT_SPOT_TRADE for payments keyd up with spot trade has funding method,
 * the spot trade isn't booked yet
 * STANDALONE for payments on their own
 */
var PaymentOrigin;
(function (PaymentOrigin) {
    PaymentOrigin["DRAWDOWN"] = "DRAWDOWN";
    PaymentOrigin["SPOT_TRADE"] = "SPOT_TRADE";
    PaymentOrigin["DRAFT_SPOT_TRADE"] = "DRAFT_SPOT_TRADE";
    PaymentOrigin["STANDALONE"] = "STANDALONE";
    PaymentOrigin["MASS_DRAWDOWN"] = "MASS_DRAWDOWN";
})(PaymentOrigin = exports.PaymentOrigin || (exports.PaymentOrigin = {}));
